import * as Yup from 'yup';

export default Yup.object().shape({
  email: Yup.string()
    .email('Please enter valid email')
    .max(100, 'Too long!')
    .required('Please enter valid email')
});
